import React from "react";
import PageLoader from "../sub/PageLoader";
import SplitPlanMainCard from "./SplitPlanElement";
import SplitPlanElement from "./SplitPlanElement";
import { Button } from "antd";
import { LIMIT_PER_PAGE } from "../../helpers/constants";

function SplitPlanTreeCards(props) {
  const limit = LIMIT_PER_PAGE;
  return (
    <>
      {props.data?.map((element) => (
        <SplitPlanElement
          data={element}
          handleDelete={(planId) => props.handleDelete(planId)}
          handleEdit={(planId) => props.handleEdit(planId)}
          onParentRefresh={props.onParentRefresh}
          onTargetUpdate={props.onTargetUpdate}
        />
      ))}
      {props.loading ? (
        <PageLoader />
      ) : (
        props.totalSplitPlanCount > props.data?.length && (
          <div className="flex items-center justify-center mt-2">
            <Button
              onClick={() => {
                props.setStartAt(props.startAt + limit);
                props.loadMore(props.startAt + limit);
              }}
            >
              Load more
            </Button>
          </div>
        )
      )}
    </>
  );
}

export default SplitPlanTreeCards;
